














import { defineComponent } from "@vue/composition-api";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "FeedNsfwNotice",
  components: { BaseButton, BaseIcon },
  setup() {
    const { showNotSafeForWork, toggleNSFWUserSettings } = useNSFWUserSettings();

    return { showNotSafeForWork, toggleNSFWUserSettings };
  },
});
